import React from 'react'
import {findDOMNode} from "react-dom"

import FirstColumn from "../item/first-column"
import LastColumn from "../item/last-column"
import {GlistHeaderMode} from "../../const"
import {GlistColumnType} from "../../manager/columns-manager/column"
import GlistHeaderCellTitle from "./cell/header-cell-title"
import {DND_HANDLE_COLUMN_WIDTH} from "../../manager/columns-manager/columns"
import GenericListModule from "../../generic-list-module"
import FieldProto from "../../../../fields3/proto/field-proto"

// @ts-ignore
import GlistHeaderActionsCell from "../actions/header-cell"
// @ts-ignore
import ListHeaderTile from "./cell/cell"
import AddColumn from "../../../common/add-column-new/add-column"

type Props = {
    className?  : string

    module      : GenericListModule
}

export default class GenericListMasterHeader extends React.Component<Props> {

    componentDidMount() {
        gd.bus.subscribe('column:resizing', this, this.onColumnResizing)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onColumnResizing = (data: any) => {
        gd.utils.Dom.toggleClass(findDOMNode(this),'is-column-resizing', data.isResizing);
    }

    onToggleColumn = (id: ID) => {this.props.module.columns.toggleColumn(id)}
    onNewColumn = (field: FieldProto) => {this.props.module.addCustomField(field)}

    render() {
        const columnsNum = this.props.module.columns.allVisible().length;

        const classes = Classes('master-header', this.props.className, {
            'sticky': this.props.module.headerMode === GlistHeaderMode.STICKY
        })

        const shellStyles = {
            minWidth: 'calc(100% - {0}px)'.f(this.props.module.skin.paddingLeft + this.props.module.skin.paddingRight + (this.props.module.canDndItems ? DND_HANDLE_COLUMN_WIDTH : 0))
        }

        return (
            <div className={classes} style={{width: this.props.module.columns.getCombinedWidth()}}>
                <div className="glist-row glist-header">
                    <FirstColumn module={this.props.module}/>
                    {this.props.module.canDndItems && <div className="dnd-handle-column"/>}

                    <div className="shell" style={shellStyles}>
                        {_.map(this.props.module.columns.allVisible(), (column,key)=>{
                            let ListHeaderComponent;
                            switch (column.type) {
                                case GlistColumnType.ACTIONS:
                                    ListHeaderComponent = GlistHeaderActionsCell; break;
                                case GlistColumnType.TITLE:
                                    ListHeaderComponent = GlistHeaderCellTitle; break;
                                default:
                                    ListHeaderComponent = ListHeaderTile; break;
                            }

                            const isTitleField      = column.fieldId === this.props.module.config.titleField
                            const canReorderTitle   = this.props.module.titleColumnReorder

                            return <ListHeaderComponent key         = {'{0}_{1}'.f(column.fieldId, key)}
                                                        dndManager  = {(!isTitleField || canReorderTitle) ? this.props.module.headerDndManager : null}
                                                        module      = {this.props.module}
                                                        column      = {column}
                                                        canRemove   = {!isTitleField && this.props.module.canAddColumns}
                                                        canMoveLeft = {canReorderTitle ? key !== 0 : key !== 1}
                                                        isFirst     = {key === 0}
                                                        isLast      = {key === columnsNum - 1}/>
                        })}

                        {this.props.module.config.canAddColumns &&
                            <div className="add-column">
                                <AddColumn className            = "btn-add-column"
                                           btnClass             = 'ui5-control-button s-24 fs-12 i5-plus'
                                           manageColumnsConfig  = {this.props.module.config.manageColumnsConfig}
                                           fields               = {this.props.module.fields.all()}
                                           columns              = {this.props.module.columns.all()}
                                           mandatoryColumnsIds  = {_.compact([this.props.module.config.titleField])}
                                           showAdd              = {this.props.module.canAddCustomColumns}
                                           onToggleColumn       = {this.onToggleColumn}
                                           onNewColumn          = {this.onNewColumn}/>
                            </div>}
                    </div>

                    {this.props.module.groupBy && <LastColumn module={this.props.module}/>}
                </div>
            </div>
        )
    }
}
